import React from 'react';
import { Container } from '@mui/material';
import { EventWrapper, IEventWrapper } from '../../EventComponents/EventWrapper';

interface IEventContainerProps extends IEventWrapper {}

const EventContainer: React.FC<IEventContainerProps> = props => {
    return (
        <Container
            disableGutters
            maxWidth={false}
            style={{
                height: 'auto',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                // overflow: 'hidden',
            }}
            sx={{
                width: '100%',
                marginTop: { xs: '0', sm: '40px', md: 0 },
                marginLeft: { xs: '0px', sm: '0px', md: '40px', xl: '100px' },
                paddingLeft: { xs: '0px', sm: '40px', md: '0px' },
                paddingRight: { xs: '0px', sm: '0px', md: '0px', xl: '100px' },
                paddingTop: { xs: '20px', sm: '20px', md: '40px', lg: '0px' },
                paddingBottom: { xs: '90px', sm: '0px' },
                marginBottom: { xs: '200px', sm: '0px' },
                overflowX: 'hidden',
            }}>
            <EventWrapper {...props} hideDetails />
        </Container>
    );
};

export { EventContainer };
